<template>
  <div class="dashboard reviews">
    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>Настройки профиля</h4>
            <div class="sub-title">Управление личной информацией и безопасностью</div>
          </div>
        </div>

        <div class="end-area">

        </div>
      </div>
      <TopBlock></TopBlock>
    </div>

    <div class="card shadow mt-2 mb-3 border-0">
      <div class="card-body">
        <h5>Личная информация</h5>
        <div class="row mb-3">
          <div class="col-6">
            <div class="form-floating">
              <input id="name" class="form-control" v-model="user_object.first_name" placeholder="Имя">
              <label for="name">Имя</label>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating">
              <input id="name" class="form-control" v-model="user_object.last_name" placeholder="Имя">
              <label for="name">Фамилия</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-floating mb-2">
              <input id="email" class="form-control" disabled :value="user_object.email" placeholder="email">
              <label for="email">Email</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col ms-auto">
            <button class="btn btn-primary" @click="updateUser"> Сохранить изменения</button>
          </div>
        </div>


      </div>
    </div>

    <div class="card shadow mt-2 mb-3 border-0">
      <div class="card-body">
        <h5>Изменить пароль</h5>

        <form @submit.prevent="changePassword" class="form-box flex-list step-32 mt-3">
          <div class="form-floating password-input mt-2 mb-2">
            <input class="form-control" required :type="show_pass?'text':'password'" v-model="password.old"
                   placeholder="Пароль">
            <label>Введите текущий пароль</label>
            <i v-on:click="show_pass=!show_pass"
               :class="`bi bi-eye${show_pass?' active':''}`"></i>
          </div>

          <div class="form-floating mb-2 password-input">
            <input class="form-control" required :type="show_pass?'text':'password'" v-model="password.newp"
                   placeholder="Пароль">
            <label>Введите новый пароль</label>
            <i v-on:click="show_pass=!show_pass" :class="`bi bi-eye${show_pass?' active':''}`"></i>
          </div>

          <div class="form-floating mb-2 password-input">
            <input class="form-control" required :type="show_pass?'text':'password'" v-model="password.repeat"
                   placeholder="Пароль">
            <label>Повторите новый пароль</label>
            <i v-on:click="show_pass=!show_pass" :class="`bi bi-eye${show_pass?' active':''}`"></i>
          </div>

          <div class="form-floating mb-2">
            <button class="btn btn-primary" type="submit">Изменить пароль</button>
          </div>
        </form>
      </div>
    </div>

    <div class="card shadow mt-2 mb-3 border-0">
      <div class="card-body">
        <h5>Уведомления</h5>

        <form @submit.prevent="updateUser" class="row mb-3 align-items-center">
          <div class="col">
            <div class="form-floating">
              <input id="name" class="form-control" required v-model="user_object.alert_email"
                     placeholder="Email для уведомлений">
              <label for="name">Email для уведомлений</label>
            </div>
          </div>
          <div class="col-lg-2">
            <button class="btn btn-primary" type="submit">Сохранить</button>
          </div>

        </form>


        <template v-if="user_object.alert_tg">
          <button @click="user_object.alert_tg=null;updateUser()" class="btn btn-outline-danger">Отключить уведомления в Telegram
            <i class="bi bi-telegram"></i></button>
        </template>
        <template v-else>
          <button v-if="!code" class="btn btn-outline-dark" @click.prevent="getCode">Подключить уведомления в Telegram
            <i class="bi bi-telegram"></i></button>
          <div class="tg-area" v-if="code">

            <Timer
                :duration="300"
            />
            <h5>Отправьте код в сообщениях с ботом <a :href="code.bot" target="_blank">{{ code.bot }}</a></h5>
            <h5 @click="copyCode()" class="tg-code">{{ code.code }}</h5>
          </div>
        </template>


      </div>
    </div>


    <div class="card shadow mt-2 mb-3 border-danger bg-danger bg-opacity-10">
      <div class="card-body">
        <div class="title">
          <h5 class="text-danger">Опасная зона</h5>
        </div>
        <div class="border border-danger border-opacity-50 bg-danger bg-opacity-10 d-flex p-3 rounded">
          <div class="title">
            <div>
              <strong>Удалить аккаунт</strong><br>
              <div class="sub-title">Безвозвратное удаление аккаунта и всех данных</div>
            </div>
          </div>
          <button class="btn btn-danger ms-auto brn-sm" disabled>Удалить</button>
        </div>
      </div>
    </div>


  </div>


</template>

<script>
import {UserApi} from '@/api/user'
import TopBlock from "@/components/TopBlock.vue";
import {state} from "@/socket";
import Timer from "@/components/Timer.vue";

export default {
  name: 'UserSettings',
  data() {
    return {
      show_pass: false,
      change_password: false,
      password: {newp: '', old: '', repeat: ''},
      user_object: {},
      code: null,
    }
  },
  components: {Timer, TopBlock},
  computed: {
    user: {
      get() {
        return this.$store.getters.user
      },
      set(value) {
        this.$store.dispatch('update_user', value)
      }
    },
    state_tg_settings(value) {
      return state.tg_settings
    },
  },
  watch: {
    state_tg_settings(value) {
      if (value.error) {
        this.$notify({
          type: 'error',
          text: value.error
        });
        this.code = null;
      } else {
        this.$notify({
          type: 'success ',
          text: 'Уведомления подключены'
        });
        this.user_object = value;
        this.code = null;
      }
    },
  },
  mounted: function () {
    UserApi.get_settings().then(resp => this.user_object = resp)

  },
  methods: {
    getCode() {
      UserApi.get_code().then(resp => this.code = resp)
    },
    copyCode() {
      try {
        navigator.clipboard.writeText(this.code.code);
        this.$notify({
          type: 'success',
          text: "Добавленно в буфер обмена"
        });
      } catch ($e) {
        console.error("can't copy")
      }
    },
    updateUser: function () {
      this.$store.dispatch('update_user', this.user_object)
      this.$notify({
        type: 'success ',
        text: 'Информация обновлена'
      });
    },
    changePassword: function () {
      const $this = this;
      if (this.password.newp !== this.password.repeat) {
        this.$notify({
          type: 'error ',
          text: 'Введённые пароли не совпадают'
        });
      } else {
        UserApi.update_password($this.password).then(response => {
          if (response.errors) {
            for (let i in response.errors) {
              $this.$notify({
                type: 'error ',
                text: response.errors[i]
              })
            }
          } else {

            if (response.tokens) {
              this.$store.commit("updateToken", response.tokens.access);
              let username = $this.user.email, password = $this.password.newp;
              this.$store.dispatch('login', {
                username,
                password
              }).then(() => {
                $this.password = {newp: '', old: '', repeat: ''};
              });
            }

          }
        });
      }

    }
  }
}

</script>
<style scoped lang="scss">

.tg-area {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);

  h5 {
    font-weight: bold;
    color: #fff;
    padding: 20px;

    &.tg-code {
      text-align: center;
      cursor: pointer;
      background: #eee;
      padding: 10px;
      border: 1px solid #ccc;
      color: #000000;
    }
  }
}
</style>
